import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04ad83a2")

_pushScopeId("data-v-04ad83a2")
const _hoisted_1 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_2 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { id: "no-words-present-info" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        end: _withId(() => [
          (_ctx.canSeeLinkTable)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "kn-button p-button-text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('linkClicked', _ctx.type)))
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.link')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    content: _withId(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.items,
        class: "p-datatable-sm kn-table",
        dataKey: "id",
        selection: _ctx.selectedItems,
        "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedItems = $event)),
        selectionMode: "multiple",
        metaKeySelection: false,
        filters: _ctx.filters,
        "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = $event)),
        globalFilterFields: _ctx.glossaryUsageNavigationCardDescriptor.globalFilterFields,
        paginator: _ctx.items.length > 5,
        rows: 5,
        responsiveLayout: "stack",
        breakpoint: "960px",
        onRowSelect: _ctx.onItemsSelected,
        onRowUnselect: _ctx.onItemsSelected
      }, {
        header: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters['global'].value = $event)),
                type: "text",
                placeholder: _ctx.$t('common.search'),
                "data-test": "search-input"
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ])
        ]),
        empty: _withId(() => [
          _createVNode("div", _hoisted_4, [
            _createVNode("p", null, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.noWordsPresent', { type: _ctx.title })), 1)
          ])
        ]),
        default: _withId(() => [
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "label",
            key: "label"
          }),
          _createVNode(_component_Column, { class: "p-text-right" }, {
            body: _withId((slotProps) => [
              _createVNode(_component_Button, {
                icon: "pi pi-info-circle",
                class: "p-button-link",
                onClick: _withModifiers(($event: any) => (_ctx.$emit('infoClicked', slotProps.data)), ["stop"]),
                "data-test": 'info-button-' + slotProps.data.id
              }, null, 8, ["onClick", "data-test"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "selection", "filters", "globalFilterFields", "paginator", "onRowSelect", "onRowUnselect"])
    ]),
    _: 1
  }))
})